/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between the Race Results and Fantasy Stats tabs?`)
};

const es_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre las pestañas Resultados de Carrera y Fantasy Stats?`)
};

const de_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen den Tabs Rennergebnisse und Fantasy-Statistiken?`)
};

const nl_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen de tabbladen Raceresultaten en Fantasy Stats?`)
};

const fr_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre les onglets Résultats de Course et Fantasy Stats ?`)
};

const it_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra le schede Risultati Gara e Fantasy Stats?`)
};

const pt_br2_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre as abas Resultados de Corrida e Fantasy Stats?`)
};

const pt_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre os separadores Resultados de Corrida e Fantasy Stats?`)
};

const ja_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レース結果タブとFantasy Statsタブの違いは何ですか？`)
};

const zh_f1_stx_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比赛结果和梦幻统计标签有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stx_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stx_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stx_faq1_q", locale)
	if (locale === "en") return en_f1_stx_faq1_q(inputs)
	if (locale === "es") return es_f1_stx_faq1_q(inputs)
	if (locale === "de") return de_f1_stx_faq1_q(inputs)
	if (locale === "nl") return nl_f1_stx_faq1_q(inputs)
	if (locale === "fr") return fr_f1_stx_faq1_q(inputs)
	if (locale === "it") return it_f1_stx_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stx_faq1_q(inputs)
	if (locale === "pt") return pt_f1_stx_faq1_q(inputs)
	if (locale === "ja") return ja_f1_stx_faq1_q(inputs)
	return zh_f1_stx_faq1_q(inputs)
};